// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__umARs","topBottomGutter":"Layout_topBottomGutter__1ud_T"};